var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHyrisFullChristmas({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 641.59 699.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\n      @keyframes blink-red {\n        0%, 25%, 75%, 100% { fill: #ff6d6d; }\n        50% { fill: #520b0b; }\n      }\n\n      @keyframes blink-green {\n        0%, 50%, 75%, 100% { fill: #1eff5f; }\n        25% { fill: #094f1d; }\n      }\n\n      @keyframes blink-blue {\n        0%, 25%, 50%, 75%, 100% { fill: #6dfcff; }\n        75% { fill: #074243; }\n      }\n\n      .red-light {\n        animation: blink-red 1s step-end infinite;\n        fill: #ff6d6d;\n      }\n\n      .green-light {\n        animation: blink-green 1s step-end infinite;\n        fill: #1eff5f;\n      }\n\n      .blue-light {\n        animation: blink-blue 1s step-end infinite;\n        fill: #6dfcff;\n      }\n\n      .hfc-st1 {\n        fill: #fff;\n      }\n\n      .hfc-st2 {\n        fill: url(#linear-gradient1);\n      }\n\n      .hfc-st3, .hfc-st4, .hfc-st5 {\n        fill: none;\n      }\n\n      .hfc-st6 {\n        fill: url(#radial-gradient);\n      }\n\n      .hfc-st4 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n\n      .hfc-st8 {\n        display: none;\n      }\n\n      .hfc-st9 {\n        fill: #888;\n      }\n\n      .hfc-st5 {\n        stroke: url(#linear-gradient);\n        stroke-miterlimit: 10;\n        stroke-width: .5px;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 167.83,
    y1: 303.89,
    x2: 178.99,
    y2: 303.89,
    gradientTransform: "translate(128.76 -43.13) rotate(22.38)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8d097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#e8ce90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#e8c97d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#e8c15e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#e8b633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8aa00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 171.4,
    y1: 313.73,
    x2: 184.12,
    y2: 313.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8d097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#e8ce90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#e8c97d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#e8c15e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#e8b633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8aa00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 193.27,
    cy: 351.56,
    fx: 181.01,
    fy: 338.33,
    r: 37.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff865f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#ff7f5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#ff6c4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ff4d36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#ff2218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "red"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    className: "hfc-st8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "hfc-st9",
    y: 0,
    width: 641.59,
    height: 699.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "hfc-st4",
    d: "M360.73,13.59c-35.89,99.56-78.38,130.55-153.19,118.34,3.82,67.63,57.17,219.36,165.45,155.11,61.84,47.66,186.82,42.1,232.85-8.04-8.95,108.54-79.8,165.88-124.42,132.38-88.66,62.99-166.4,3.24-193.96-36-55.54,55.33-128.11,89.79-184.85,40.73.37,24.62,34.32,186.56,104.55,123.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "hfc-st1",
    d: "M283.85,337.41c.02-10.66-.79-21.26-2.17-31.82-1.84-14.06-5.11-27.8-9.13-41.38-.43-1.45-.79-2.94-1.02-4.43-.21-1.36.31-2.18,1.31-2.54,1.29-.46,2.47-.1,3.19,1.1.49.81.89,1.68,1.26,2.55,5.49,13.17,9.66,26.76,12.67,40.71,2.05,9.48,3.45,19.05,4.41,28.7.25,2.55.5,5.11.54,7.68.13,8.45.39,16.91-.22,25.36-.41,5.69-.99,11.35-1.79,17-1.5,10.64-3.78,21.11-6.64,31.46-6.66,24.01-16.65,46.6-29.22,68.08-14.11,24.12-30.8,46.33-49.5,67.07-22.97,25.48-48.15,48.58-75.1,69.77-39.61,31.14-81.87,58.17-126.53,81.47-.84.44-1.69.87-2.59,1.16-1.26.41-2.51-.05-3.01-.96-.57-1.03-.34-2.54.64-3.38.72-.61,1.53-1.12,2.33-1.64,14.85-9.74,29.73-19.44,44.32-29.58,27.4-19.04,54.04-39.08,79.52-60.64,24.85-21.02,48.35-43.44,69.88-67.88,16.05-18.21,30.83-37.37,43.65-58,12.32-19.81,22.69-40.57,30.2-62.71,4.49-13.24,7.86-26.75,10.11-40.55,1.96-12.13,2.85-24.33,2.89-36.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hfc-st1",
    d: "M87.94,351.65c0-4.12-.05-7.07.01-10.01.17-8.66,1.15-17.26,2.52-25.79,3.01-18.71,8.06-36.87,15.02-54.51,8.02-20.3,18.29-39.41,30.25-57.64,13.8-21.03,29.52-40.53,46.73-58.86,24.06-25.64,50.34-48.8,78.34-70.03,36.56-27.72,75.25-52.09,115.92-73.33.92-.48,1.85-.99,2.83-1.32,1.25-.42,2.4.03,3,.99.64,1.03.45,2.43-.58,3.35-.71.62-1.53,1.13-2.32,1.65-14.23,9.31-28.47,18.6-42.45,28.27-29.4,20.34-57.93,41.83-85.09,65.08-23.57,20.18-45.88,41.65-66.39,64.95-15.91,18.07-30.58,37.09-43.32,57.55-11.68,18.74-21.61,38.35-29.05,59.18-5.22,14.61-9.09,29.56-11.52,44.88-1.37,8.64-2.14,17.33-2.6,26.07-.45,8.66-.27,17.3.34,25.92,1.2,16.9,4,33.55,8.67,49.86.94,3.28,1.85,6.58,2.76,9.87.18.64.33,1.29.39,1.95.13,1.4-.43,2.28-1.6,2.68-1.09.37-2.21-.02-2.91-1.18-.54-.89-.95-1.86-1.36-2.81-2.37-5.59-4.45-11.3-6.33-17.08-4.33-13.3-7.42-26.9-9.36-40.74-1.4-10-2.33-20.02-1.9-28.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hfc-st1",
    d: "M583.09,429.57c-9.22,0-18.44.02-27.66-.01-3.63-.01-3.04.33-3.29-3.24-.17-2.47-.09-4.94.11-7.4.09-1.13.32-1.36,1.34-1.43.57-.04,1.14-.01,1.71-.01,16.25,0,32.51-.02,48.76,0,4.19,0,8.35-.31,12.47-1.11.84-.16,1.68-.33,2.49-.59,5.4-1.76,8.5-5.43,9.28-11.1.51-3.72-.09-7.18-1.86-10.46-1.54-2.85-3.41-5.48-5.46-7.98-3.99-4.86-8.4-9.31-13.02-13.57-7.47-6.89-14.97-13.76-22.44-20.66-6.49-6-12.82-12.17-18.63-18.85-3.63-4.16-6.99-8.52-9.77-13.3-1.96-3.38-3.59-6.9-4.43-10.75-2.03-9.34.29-22.37,12.54-29.32,4.09-2.32,8.48-3.79,13.05-4.77,4.29-.91,8.63-1.37,13.01-1.38,13.59-.01,27.18-.03,40.77-.03,2.78,0,2.84.03,2.92,2.84.07,2.56.04,5.13-.02,7.69-.02,1.12-.47,1.49-1.6,1.55-.57.03-1.14-.02-1.71-.02-12.07.01-24.14-.12-36.21.21-4.94.14-9.88.36-14.7,1.63-1.74.46-3.47,1-5.15,1.62-1.15.42-2.27.98-3.32,1.61-5.18,3.06-7.4,7.67-7.06,13.61.18,3.08.98,5.98,2.24,8.78,1.68,3.75,3.93,7.15,6.41,10.4,3.18,4.16,6.72,8,10.39,11.73,5.21,5.28,10.71,10.24,16.22,15.21,5.43,4.9,10.87,9.79,16.27,14.74,5.47,5.01,10.7,10.26,15.42,16,2.54,3.09,4.73,6.41,6.69,9.9,4.53,8.06,3.02,19.97-1.44,26.67-2.05,3.08-4.75,5.4-7.98,7.16-4.06,2.21-8.46,3.32-12.99,4-3.49.52-7,.64-10.52.63h-.86c-7.33,0-14.65,0-21.97,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hfc-st1",
    d: "M346.29,375.54c0-14.83.01-29.65-.01-44.48-.01-6.97.7-13.84,2.42-20.6.66-2.58,1.44-5.12,2.45-7.58,4.43-10.73,12.09-18.25,22.74-22.78,6.16-2.62,12.59-4.23,19.2-5.13,3.1-.42,6.24-.65,9.36-.95.66-.06,1.33-.08,1.99-.07.53.01.88.32,1.02.82.1.36.17.74.19,1.12.2,3.23.21,6.46.04,9.69-.07,1.26-.49,1.73-1.77,1.66-2.67-.15-5.33.05-7.97.27-5.71.49-11.27,1.67-16.51,4.06-10.06,4.6-16.1,12.37-18.26,23.21-.64,3.19-.77,6.41-.86,9.64-.06,2.18-.02,4.37-.02,6.56v95.52c0,.57,0,1.14-.06,1.71-.09.94-.3,1.2-1.19,1.24-3.8.2-7.6.2-11.4-.03-1.05-.06-1.29-.35-1.36-1.42-.03-.47-.02-.95-.02-1.42v-51.04h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hfc-st1",
    d: "M487.55,351.97v74.09c0,3.5.26,3.51-3.35,3.48-2.85-.02-5.7,0-8.55-.03-1.23-.01-1.48-.27-1.58-1.49-.06-.76-.05-1.52-.05-2.28v-146.48c0-.57-.01-1.14.01-1.71.12-4.48-.64-3.74,3.71-3.9,2.75-.1,5.51.03,8.26.11,1.22.04,1.45.31,1.51,1.55.04.85.02,1.71.02,2.56v74.09s0,.01.02.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hfc-st3",
    d: "M189.3,322.09c-4.47-.02-7.74.54-10.94,1.51-.92.28-1.81.54-2.78.51-.93-.03-1.63-.39-2.07-1.25-.48-.94-.42-1.83.16-2.69.44-.65,1.11-1,1.77-1.39,20.91-12.26,46.46-.99,53.09,21.43,4.45,15.06-1.09,34.48-17.13,43.92-5.69,3.35-11.81,5.3-18.41,5.24-10.83-.1-19.66-4.56-26.42-12.99-4.94-6.16-7.19-13.29-7.22-21.15-.01-1.44.19-2.85.54-4.23.3-1.18,1.12-1.84,2.19-1.94,1.19-.1,2.13.49,2.61,1.77.23.61.31,1.29.42,1.94.6,3.67,1.55,7.24,3.3,10.55,3.8,7.2,9.67,11.85,17.55,13.86,4.26,1.09,8.51.8,12.61-.74,7.31-2.74,13.16-7.25,16.39-14.53,7.42-16.73-1.78-35.38-19.7-39.16-2.35-.49-4.71-.61-5.96-.66Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "hfc-st5",
    cx: 173.41,
    cy: 303.89,
    rx: 5.14,
    ry: 6.32,
    transform: "translate(-102.64 88.91) rotate(-22.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hfc-st2",
    d: "M179.84,307.56l-8.23,3.37c-.16.07-.24.24-.19.41l2.85,8.36c.06.18.26.27.43.2l9.22-3.77c.17-.07.25-.28.17-.45l-3.83-7.96c-.08-.16-.26-.23-.42-.16Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "hfc-st6",
    cx: 193.27,
    cy: 351.56,
    rx: 36.74,
    ry: 37.81
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "green-light",
    cx: 321.86,
    cy: 417.04,
    rx: 7.45,
    ry: 4.65,
    transform: "translate(-200.92 482.03) rotate(-59.43)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "green-light",
    cx: 531.85,
    cy: 320.58,
    rx: 4.65,
    ry: 7.45,
    transform: "translate(-57.91 126.1) rotate(-12.83)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "green-light",
    cx: 254.19,
    cy: 138.62,
    rx: 4.65,
    ry: 7.45,
    transform: "translate(-14.06 29.68) rotate(-6.5)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "green-light",
    cx: 136.23,
    cy: 440.44,
    rx: 7.45,
    ry: 4.65,
    transform: "translate(-323.86 469.77) rotate(-76.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "red-light",
    cx: 242.51,
    cy: 253.79,
    rx: 7.45,
    ry: 4.65,
    transform: "translate(-84.96 380.23) rotate(-67.41)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "red-light",
    cx: 514.8,
    cy: 425.85,
    rx: 7.45,
    ry: 4.65,
    transform: "translate(42.08 897.97) rotate(-84.56)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "red-light",
    cx: 144.85,
    cy: 542.27,
    rx: 7.45,
    ry: 4.65,
    transform: "translate(-416.37 533.53) rotate(-74.15)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "red-light",
    cx: 415.61,
    cy: 313.74,
    rx: 7.45,
    ry: 4.65,
    transform: "translate(24.02 656.99) rotate(-78.28)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "blue-light",
    cx: 340.07,
    cy: 69.39,
    rx: 4.65,
    ry: 7.45,
    transform: "translate(-6.92 77.25) rotate(-12.83)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "blue-light",
    cx: 240.36,
    cy: 421.25,
    rx: 4.65,
    ry: 7.45,
    transform: "translate(-198.77 215.37) rotate(-35.17)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "blue-light",
    cx: 601.43,
    cy: 330.36,
    rx: 4.65,
    ry: 7.45,
    transform: "translate(-80.38 407.8) rotate(-35.26)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "blue-light",
    cx: 461.07,
    cy: 429.59,
    rx: 4.65,
    ry: 7.45,
    transform: "translate(-77.14 101.77) rotate(-11.63)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyrisFullChristmas);
export default __webpack_public_path__ + "static/media/hyris-full-christmas.1e1df31d0aaca7cf5399ac6d61333b04.svg";
export { ForwardRef as ReactComponent };